import React from 'react'

export const CopyIcon = ( ) => {
    return <div style={{display: 'flex'}}>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 1.5H4C2.9 1.5 2 2.4 2 3.5V16.5C2 17.05 2.45 17.5 3 17.5C3.55 17.5 4 17.05 4 16.5V4.5C4 3.95 4.45 3.5 5 3.5H15C15.55 3.5 16 3.05 16 2.5C16 1.95 15.55 1.5 15 1.5ZM19 5.5H8C6.9 5.5 6 6.4 6 7.5V21.5C6 22.6 6.9 23.5 8 23.5H19C20.1 23.5 21 22.6 21 21.5V7.5C21 6.4 20.1 5.5 19 5.5ZM18 21.5H9C8.45 21.5 8 21.05 8 20.5V8.5C8 7.95 8.45 7.5 9 7.5H18C18.55 7.5 19 7.95 19 8.5V20.5C19 21.05 18.55 21.5 18 21.5Z" fill="#A1ADBA"/>
</svg>

    </div>
}